import React from "react";
import lockupSrc from "@/assets/zen529-lockup.svg";
import loginLockupSrc from "@/assets/zen529-lockup-login.svg";

/**
 * Zen 529 brand lockup — full wordmark (coin + "Zen 529" + "Know As You Go").
 * Font-independent: all text is outlined to vector paths in the SVG.
 *
 * Designed for LIGHT backgrounds only (blue + green on white/gray).
 *
 * Props:
 *   height — rendered height in px (width auto, preserves 620:190 aspect ratio).
 */
export function Lockup({ height = 40 }) {
  return (
    <img
      src={lockupSrc}
      height={height}
      alt="Zen 529 — Know As You Go"
      data-testid="logo-lockup"
      style={{ display: "block", height, width: "auto", userSelect: "none" }}
      draggable={false}
    />
  );
}

/**
 * Zen 529 login lockup — same layout as Lockup but colored for DARK / blue
 * backgrounds (white "Zen", green "529", white tagline + white "Know As You Go").
 *
 * Props:
 *   height — rendered height in px (width auto, preserves 620:190 aspect ratio).
 */
export function LoginLockup({ height = 80 }) {
  return (
    <img
      src={loginLockupSrc}
      height={height}
      alt="Zen 529 — Know As You Go"
      data-testid="logo-lockup-login"
      style={{ display: "block", height, width: "auto", userSelect: "none" }}
      draggable={false}
    />
  );
}
